import { ButtonPosition } from '@/common/manager/position/button-position';
import { getDownloadProps, getRealizeValue, renderIcon, } from '@/common/util/util';
import { CnDownload } from '@cainiaofe/cn-ui';
export const config = {
    value: 'download',
    position: [
        ButtonPosition.tableBatchArea,
        ButtonPosition.subCardAction,
        ButtonPosition.cardAction,
    ],
    getRenderDom: (config) => {
        const { buttonConfig, recordDataSource, state, urlParamsDataSource, btnProps, } = config || {};
        const { children, options, iconType } = buttonConfig || {};
        const { url } = options || {};
        const downloadProps = getDownloadProps({
            url,
            recordDataSource: getRealizeValue(recordDataSource) || {},
            state,
            extraParams: {
                urlParamsDataSource,
                needFormatResult: true,
            },
        });
        let realChildren = children;
        if (iconType) {
            realChildren = (<>
          {renderIcon(iconType)}
          {children}
        </>);
        }
        return (<CnDownload buttonText={realChildren} size="small" {...btnProps} {...downloadProps}/>);
    },
};
